/**
 * =============================================================================
 * IDS CRM Web - Shared toast notices + useToast (Batch E UX system)
 * =============================================================================
 *
 * Replaces alert() across the app with non-blocking dismissible notices.
 *
 *   const { toastElement, showToast } = useToast();
 *   showToast('Failed to save', 'error');   // or 'success' | 'info'
 *   return (<div>... {toastElement}</div>);
 *
 * =============================================================================
 */

import React, { useState, useCallback, useRef } from 'react';
import './Toast.css';

export function useToast() {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(1);

  const dismiss = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);

  const showToast = useCallback((message, type = 'info') => {
    const id = nextId.current++;
    setToasts(prev => [...prev, { id, message, type }]);
    // Errors stay until dismissed; success/info auto-clear
    if (type !== 'error') {
      setTimeout(() => dismiss(id), 4000);
    }
  }, [dismiss]);

  const toastElement = toasts.length > 0 ? (
    <div className="toast-stack">
      {toasts.map(toast => (
        <div key={toast.id} className={`toast toast-${toast.type}`}>
          <span>{toast.message}</span>
          <button type="button" onClick={() => dismiss(toast.id)}>&times;</button>
        </div>
      ))}
    </div>
  ) : null;

  return { toastElement, showToast };
}

export default useToast;
